import emailjs from '@emailjs/browser';

const SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID || 'service_07aohi5';
const APPOINTMENT_TEMPLATE_ID = import.meta.env.VITE_EMAILJS_APPOINTMENT_TEMPLATE_ID || 'template_3aqwyiy';
const CONTACT_TEMPLATE_ID = import.meta.env.VITE_EMAILJS_CONTACT_TEMPLATE_ID || 'template_hv65clm';
const PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY || '2As-e2bQUm1J9KLur';

const isEmailConfigured = () => {
  return PUBLIC_KEY && PUBLIC_KEY !== '' && PUBLIC_KEY !== 'YOUR_PUBLIC_KEY';
};

interface AppointmentData {
  fullName: string;
  email?: string;
  phone: string;
  department: string;
  preferredDate: string;
  message?: string;
}

interface ContactData {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  subject: string;
  message: string;
}

export async function sendAppointmentEmail(data: AppointmentData): Promise<void> {
  if (!isEmailConfigured()) {
    console.warn('EmailJS not configured. Email will not be sent.');
    throw new Error('EMAIL_NOT_CONFIGURED');
  }

  const templateParams = {
    to_email1: 'musssaaloyce4109@gmail.com',
    to_email2: 'daninatai8@gmail.com',
    patient_name: data.fullName,
    patient_email: data.email || 'Not provided',
    patient_phone: data.phone,
    department: data.department,
    preferred_date: new Date(data.preferredDate).toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }),
    message: data.message || 'No additional message',
    submission_date: new Date().toLocaleString('en-US', {
      dateStyle: 'full',
      timeStyle: 'short'
    })
  };

  try {
    await emailjs.send(SERVICE_ID, APPOINTMENT_TEMPLATE_ID, templateParams, PUBLIC_KEY);
    console.log('Appointment email sent successfully');
  } catch (error) {
    console.error('Failed to send appointment email:', error);
    throw error;
  }
}

export async function sendContactEmail(data: ContactData): Promise<void> {
  if (!isEmailConfigured()) {
    console.warn('EmailJS not configured. Email will not be sent.');
    throw new Error('EMAIL_NOT_CONFIGURED');
  }

  const templateParams = {
    to_email1: 'musssaaloyce4109@gmail.com',
    to_email2: 'daninatai8@gmail.com',
    from_name: `${data.firstName} ${data.lastName}`,
    from_email: data.email,
    from_phone: data.phone || 'Not provided',
    subject: data.subject,
    message: data.message,
    submission_date: new Date().toLocaleString('en-US', {
      dateStyle: 'full',
      timeStyle: 'short'
    })
  };

  try {
    await emailjs.send(SERVICE_ID, CONTACT_TEMPLATE_ID, templateParams, PUBLIC_KEY);
    console.log('Contact email sent successfully');
  } catch (error) {
    console.error('Failed to send contact email:', error);
    throw error;
  }
}

export default {
  sendAppointmentEmail,
  sendContactEmail,
};
